import { VhcRecordLogService, VHCRecordPartInput } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateBreakPartsInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordPartInput;
};

export const useSaveBreakPartsMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsBrakesParts, CreateBreakPartsInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: CreateBreakPartsInput) =>
      VhcRecordLogService.postVhcRecordsItemsBrakesParts(logId, itemId, requestBody),
    options
  );
